<template>
  <v-card class="pa-2">
    <v-card-title>
      {{title}}
    </v-card-title>
    <v-layout>
      <v-form ref="form">
        <v-layout class="pl-3 ml-3">
          <v-flex xs4>
            <v-text-field
            v-model="name"
            label="配置名称"
            :rules="[$rules.requiredS()]"></v-text-field>
          </v-flex>
        </v-layout>
        <l-select-controller
        v-model="preControllers"
        :required="isRequired"
        :pass-type="'person'"></l-select-controller>
      </v-form>
    </v-layout>
    <v-layout justify-center>
      <v-btn flat @click="cancel" color="grey">取消</v-btn>
      <v-btn color="primary" flat @click="confirm">确定</v-btn>
    </v-layout>
  </v-card>
</template>
<script>
import LSelectController from '../../../../components/LSelectController'
export default{
  name: 'preControllersConfig',
  components: {LSelectController},
  props: {
    status: {type: String, default: ''},
    rawItem: {type: Array},
    rawName: {type: String}
  },
  data () {
    return {
      preControllers: [],
      name: '',
      isRequired: true
    }
  },
  computed: {
    title () {
      if (this.status === 'new') {
        return '添加配置'
      }
      else if (this.status === 'edit') {
        this.name = this.rawName
        return '编辑配置'
      }
    }
  },
  created () {
    console.log(this.rawItem)
    this.preControllers = this.rawItem
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      if (this.$refs.form.validate()) {
        this.$emit('confirm', {newItem: this.preControllers, oldItem: this.rawItem, status: this.status, name: this.name})
      }
    }
  }
}
</script>
